<p>module-activity-page works!</p>
